import { throwErrorWithId } from '@pypestream/utils';

import { getCustomerPypes, loadPypeConfig } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { Pype } from '../prostudio.api-service.types';

export const loadBotPypes = async (
  ctx: ProStudioContext,
  _event: ProStudioEvents
): Promise<{ botPypes: Pype[] }> => {
  const { botName, customerId, project, solutions } = ctx;

  if (!project) {
    throwErrorWithId('Project is required');
    return { botPypes: [] };
  }

  if (!botName) {
    throwErrorWithId('Bot Name is required');
    return { botPypes: [] };
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
    return { botPypes: [] };
  }

  const uniqueCustomerId = project?.projectProStudioSetting?.customerId;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return { botPypes: [] };
  }

  if (!uniqueCustomerId) {
    throwErrorWithId('Customer ID is required');
    return { botPypes: [] };
  }

  const selectedBot = solutions?.find(
    (solution) => solution.name === botName || solution.displayName === botName
  );

  const botId = selectedBot?.botSolutionId;

  if (!botId) {
    throwErrorWithId('Bot ID is required');
    return { botPypes: [] };
  }

  const { live: livePypes, sandbox: sandboxPypes } = await getCustomerPypes({
    uniqueCustomerId,
    projectId,
    botId,
  });

  const botPypes = [...livePypes, ...sandboxPypes];

  const botPypesWithConfig = await Promise.all(
    botPypes.map(async (pype) => {
      if (!pype.id) {
        throwErrorWithId('Pype ID is required');
        return { ...pype, config: {} };
      }

      const config = await loadPypeConfig({
        pypeId: pype.id,
        env: pype.env,
        projectId,
      });
      return { ...pype, ...config };
    })
  );

  return {
    botPypes: botPypesWithConfig as Pype[],
  };
};
